<div class="progress-container" *ngIf="profile$ | async; let profile">
  <div class="progress-text">
    <h1>{{ 'progress.greeting' | translate: { name: profile.firstName } }}</h1>
    <p>
      {{ 'progress.welcome' | translate }}<br />
      {{ 'progress.description' | translate }}
    </p>
  </div>
  <app-progress-bar></app-progress-bar>
  <app-button
    *ngIf="profileProgress < 70 && !profile.completed"
    [title]="'progress.complete_profile' | translate"
    routerLink="/profile"
  ></app-button>
  <app-button
    *ngIf="profileProgress < 70 && profile.completed"
    [title]="'progress.join_create_group' | translate"
    routerLink="/profile/company"
  ></app-button>
  <div class="management">
    <app-button
      (click)="setStep(3)"
      *ngIf="profileProgress >= 70"
      [title]="'progress.manage_drones' | translate"
      routerLink="/resources"
    ></app-button>
    <app-button
      *ngIf="profileProgress >= 70 && profile.role === UserRole.ADMIN"
      [title]="'progress.manage_pilots' | translate"
      routerLink="/profile/members"
    ></app-button>
  </div>
</div>
